:host {
  display: grid;
  width: 100%;
  height: 100%;
  grid-template:
    "img content button" 1fr
    "progress-bar progress-bar progress-bar" min-content
    / min-content 1fr min-content;
}
:host(.pause-on-hover:hover) {
  ::part(indicator) {
    animation-play-state: paused;
  }
}
::slotted([slot="button"]) {
  pointer-events: none;
}
.image {
  max-width: 40px;
  height: 40px;
  grid-area: img;
  align-self: center;
}

.content {
  grid-area: content;
}

.close-button {
  grid-area: button;
  .close-button-img {
    -webkit-mask: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.875 18L6.75 16.875L11.25 12.375L6.75 7.875L7.875 6.75L12.375 11.25L16.875 6.75L18 7.875L13.5 12.375L18 16.875L16.875 18L12.375 13.5L7.875 18Z'/%3E%3C/svg%3E")
      50% 50% / 24px 24px no-repeat;
    width: 24px;
    height: 24px;
    background-color: currentColor;
  }
}

.indicator-container {
  grid-area: progress-bar;
}

:where(button) {
  all: unset;
  display: flex;
  align-items: center;
  cursor: pointer;
}
